document.addEventListener("DOMContentLoaded",function() {
	const personCards = document.getElementsByClassName("open-bio");
	const closeBios  = document.getElementsByClassName("biography-close");
	if(personCards.length || closeBios.length) {
		for (let i = 0; i < personCards.length; i++) {
			personCards[i].addEventListener("click", function () {
				let bio = this.parentNode.closest('.block-people__block');
				bio.querySelector('.block-people__biography').classList.add("block-people__biography--active");
			});
		}

		for (let i = 0; i < closeBios.length; i++) {
			closeBios[i].addEventListener("click", function () {
				this.parentNode.closest('.block-people__block').querySelector('.block-people__biography').classList.remove("block-people__biography--active");
			});
		}
	}
});